import { httpservice } from '../services';
import { constants } from '../constant/constant';

export const forgotPassword = (mailInfo) => httpservice()
  .post(`${constants.API.FORGOT_PASSWORD}`, mailInfo)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const changePassword = (passwordInfo) => httpservice()
  .post(`${constants.API.CHANGE_PASSWORD}`, passwordInfo)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const userChangePassword = (passwordInfo) => httpservice()
  .post(`${constants.API.USER_CHANGE_PASSWORD}`, passwordInfo)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => (error.response && error.response.data ? error.response.data : error));
